import {Component} from '@angular/core';

@Component({
    moduleId: module.id,
    selector: 'page-not-found',
    templateUrl: 'page-not-found.component.html'
})
export class PageNotFound {
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/pageNotFound/page-not-found.component.ts